import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";

import useAccountSettings from "../../ManageAccount/useAccountSettings";
import { useTime } from "../TimelineItem/TimelineText";
import NoteDialog from "./NoteDialog";
import importNote from "./importNote";

const initNoteDialog = { open: false, type: "" };

export default function NoteContent({ event, filterOnView }) {
  const { t } = useTranslation();
  const note = importNote(event);
  const [dialog, setDialog] = useState(initNoteDialog);
  const {
    accountSettings: { firstName },
  } = useAccountSettings();
  const title =
    event.title === "" ? t("create.note").toLowerCase() : event.title;
  const time = useTime({ start: note.time });

  // Handle editing
  const handleOpenNote = () => setDialog({ open: true, type: "note" });

  const handleClose = () => setDialog(initNoteDialog);

  return (
    <div>
      <ListItem button onClick={handleOpenNote}>
        <div>
          <Typography variant="body2">
            <Trans i18nKey={"timeline.added"} alias={firstName} title={title}>
              {{ alias: firstName }} has added {{ title }}
            </Trans>
          </Typography>
          <Typography variant="body2" style={{ whiteSpace: "pre-line" }}>
            {`${note.subtitle} • ${time}`}
          </Typography>
        </div>
      </ListItem>
      {dialog.type === "note" ? (
        <NoteDialog
          open={dialog.open}
          handleClose={handleClose}
          initNote={event}
        />
      ) : null}
    </div>
  );
}
